import styled from "styled-components"
import { motion } from "framer-motion"
import { portfolio as t } from "../Themes"

export const Section = styled.section`
position: relative;
padding: clamp(5rem, 10vw, 8rem) clamp(1.25rem, 5vw, 4rem) clamp(6rem, 11vw, 9rem);
background-color: ${(p) => (p.alt ? t.bgAlt : t.bg)};
`

export const Inner = styled.div`
width: 100%;
max-width: 1100px;
margin: 0 auto;
`

export const Label = styled(motion.p)`
font-family: ${t.mono};
font-size: 0.85rem;
color: ${t.accent};
letter-spacing: 0.06em;
margin-bottom: 0.9rem;
display: flex;
align-items: center;
gap: 0.6rem;

&::before{
    content: "${(p) => p.num || "00"}";
    color: ${t.faint};
}
&::after{
    content: "";
    flex: 0 0 auto;
    width: clamp(2rem, 8vw, 5rem);
    height: 1px;
    background: ${t.border};
}
`

export const Heading = styled(motion.h2)`
font-size: clamp(1.9rem, 4.5vw, 3rem);
margin-bottom: 1rem;
max-width: 18ch;
text-wrap: balance;
`

export const Lead = styled(motion.p)`
color: ${t.muted};
max-width: 60ch;
font-size: 1.05rem;
margin-bottom: 3rem;
`

// Shared scroll-reveal presets
export const reveal = {
    initial: { opacity: 0, y: 26 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.6, ease: "easeOut" },
}

export const revealDelay = (i = 0) => ({
    initial: { opacity: 0, y: 26 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.55, ease: "easeOut", delay: i * 0.07 },
})
